import { render, staticRenderFns } from "./RankSlider.vue?vue&type=template&id=63dc73ae&scoped=true&"
import script from "./RankSlider.vue?vue&type=script&lang=ts&"
export * from "./RankSlider.vue?vue&type=script&lang=ts&"
import style0 from "./RankSlider.vue?vue&type=style&index=0&id=63dc73ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dc73ae",
  null
  
)

export default component.exports